module.exports = __webpack_public_path__ + "images/darkIntro.8450acef.svg";